import {axiosPlacement} from "../services/AxiosInstance"

const API_URL = "/placementofficers"

// ✅ Get all placement officers (with pagination & search)
export const getPlacementOfficers = async (limit = 10, page = 1, filters = {}) => {
  try {
    const response = await axiosPlacement.get(API_URL, {
      params: {
        ...filters,
        limit,
        page
      }
    })
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching placement officers", error)
    throw error
  }
}

// ✅ Create a new placement officer
export const createPlacementOfficer = async (officerData) => {
  try {
    const response = await axiosPlacement.post(API_URL, officerData)
    return response.data
  } catch (error) {
    console.error("Error creating placement officer", {
      error: error.response?.data,
      requestData: officerData,
    })
    throw error
  }
}

// ✅ Update a placement officer by ID
export const updatePlacementOfficer = async (officerId, officerData) => {
  try {
    const response = await axiosPlacement.put(`${API_URL}/${officerId}`, officerData)
    return response.data
  } catch (error) {
    console.error("Error updating placement officer", error)
    throw error
  }
}

// ✅ Delete a placement officer by ID
export const deletePlacementOfficer = async (officerId) => {
  try {
    const response = await axiosPlacement.delete(`${API_URL}/${officerId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting placement officer", error)
    throw error
  }
}

// ✅ Get a placement officer by internal ID
export const getPlacementOfficerById = async (officerId) => {
  try {
    const response = await axiosPlacement.get(`${API_URL}/${officerId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching placement officer details", error)
    throw error
  }
}

// ✅ Get a placement officer by external officerId (if backend supports)
export const getPlacementOfficerByOfficerId = async (officerId) => {
  try {
    const response = await axiosPlacement.get(`/placement-officers/officer/${officerId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching placement officer details", error)
    throw error
  }
}

// ✅ Get jobs assigned to a placement officer
export const getPlacementOfficerJobs = async (officerId, page = 1, limit = 10, filters = {}) => {
  try {
    const response = await axiosPlacement.get(`${API_URL}/placementofficerjobs`, {
      params: {
        ...filters,
        assignedToId: officerId,
        page,
        limit
      }
    })
    return {
      data: response.data.data,
      pagination: response.data.pagination,
      message: response.data.message
    }
  } catch (error) {
    console.error("Error fetching placement officer jobs", error)
    throw error
  }
}
// ✅ Get organizations assigned to a placement officer
export const getPlacementOfficerOrgs = async (officerId, page = 1, limit = 10) => {
  try {
    const response = await axiosPlacement.get(`${API_URL}/placementofficerorgs`, {
      params: {
        assignedToIds: officerId,
        page,
        limit
      }
    })
    return {
      data: response.data.data,
      pagination: response.data.pagination,
      message: response.data.message
    }
  } catch (error) {
    console.error("Error fetching placement officer organizations", error)
    throw error
  }
}
